import React, {PureComponent} from 'react'
import { Close } from '@mui/icons-material';
import Modal from '@mui/material/Modal'
import { Box } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default ({className, isOpen = false, handleCloseModal, title, children, priority, userCanClose = true, showConfirmationButton = false, buttonText = 'OK'}) => {
  return (
    <Modal
      open={isOpen}
      onClose={() => handleCloseModal()}
    >
      <Box className={className} sx={style}>
        {userCanClose ? <div className='modal__close'><button onClick={() => handleCloseModal()} type='button'><Close className="btn-point-events" /></button></div> : null}
        <div>
          <h2>{title}</h2>
          { priority === '1' && <span className="important-tag"> Important </span> }
        </div>
        {children}

        {showConfirmationButton ? (
        <div className="row mt-30" style={{ justifyContent: 'center' }}>
          <div className="col-sm-12 col-md-6">
            <button
              className="btn btn-primary"
              //style={{width: 180}}
              onClick={() => handleCloseModal()}
              onKeyDown={event => {
                if ((event.key === 'Enter' || event.key === ' ') && document.activeElement === event.target) {
                  event.preventDefault()
                  handleCloseModal()
                }
              }}
            >
              {buttonText}
            </button>
          </div>
        </div>
      ) : null}
      </Box>
      
    </Modal>
  )
}
